import { Injectable, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EncryptdecryptService } from '../services/encryptdecrypt.service';
import { ApiservicesService } from '../apiservices.service';
import { APP_CONFIG, AppConfig } from '../app-config';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(@Inject(APP_CONFIG) private config: AppConfig, private apiService: ApiservicesService, private encryptDecryptService: EncryptdecryptService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const MyTaxAddress = this.config.MyTaxAddress;
    //const resultTimeInterval = this.apiService.RequestToken();
    //JWTToken
    //const token = this.encryptDecryptService.decrypt(sessionStorage.getItem('JWTToken') || '');
    const token = sessionStorage.getItem('access_token_oauth');
    
      // Only set Content-Type if body is NOT FormData
      let headersConfig: any = {
        "Access-Control-Allow-Methods": "GET,POST",
        "Access-Control-Allow-Origin": "*",
        "Authorization": "Bearer " + token
      };

      // If body is NOT FormData, set Content-Type (example: application/json)
      if (!(request.body instanceof FormData)) {
        headersConfig["Content-Type"] = "text/json";
      }

    request = request.clone({
      setHeaders: headersConfig
    });

    return next.handle(request).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          alert("Sila log masuk dari a MyTax");
          document.location.href = MyTaxAddress;
        }
      }));
  }
}
